import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import HalfBorderedGrid from './HalfBorderedGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, HalfBorderedGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/grid/demos/half-bordered/HalfBorderedGrid.tsx",
    "fileName": "HalfBorderedGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function HalfBorderedGrid() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const colWidth = { xs: 12, sm: 6, md: 4, lg: 3 } as const;\n  return (\n    <Box sx={{ flexGrow: 1, p: 2 }}>\n      <Grid\n        container\n        sx={(theme) => ({\n          '--Grid-borderWidth': '1px',\n          borderTop: 'var(--Grid-borderWidth) solid',\n          borderColor: 'divider',\n          '& > div': {\n            borderRight: 'var(--Grid-borderWidth) solid',\n            borderBottom: 'var(--Grid-borderWidth) solid',\n            borderColor: 'divider',\n            ...(Object.keys(colWidth) as Array<keyof typeof colWidth>).reduce(\n              (result, key) => ({\n                ...result,\n                [`&:nth-of-type(${12 / colWidth[key]}n)`]: {\n                  [theme.breakpoints.only(key)]: {\n                    borderRight: 'none',\n                  },\n                },\n              }),\n              {},\n            ),\n          },\n        })}\n      >\n        {[...Array(6)].map((_, index) => (\n          <Grid key={index} size={colWidth} sx={{ minHeight: 160 }} />\n        ))}\n      </Grid>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 38,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function HalfBorderedGrid() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const colWidth = { xs: 12, sm: 6, md: 4, lg: 3 } as const;\n  return (\n    <Box sx={{ flexGrow: 1, p: 2 }}>\n      <Grid\n        container\n        sx={(theme) => ({\n          '--Grid-borderWidth': '1px',\n          borderTop: 'var(--Grid-borderWidth) solid',\n          borderColor: 'divider',\n          '& > div': {\n            borderRight: 'var(--Grid-borderWidth) solid',\n            borderBottom: 'var(--Grid-borderWidth) solid',\n            borderColor: 'divider',\n            ...(Object.keys(colWidth) as Array<keyof typeof colWidth>).reduce(\n              (result, key) => ({\n                ...result,\n                [`&:nth-of-type(${12 / colWidth[key]}n)`]: {\n                  [theme.breakpoints.only(key)]: {\n                    borderRight: 'none',\n                  },\n                },\n              }),\n              {},\n            ),\n          },\n        })}\n      >\n        {[...Array(6)].map((_, index) => (\n          <Grid key={index} size={colWidth} sx={{ minHeight: 160 }} />\n        ))}\n      </Grid>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 38,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
